export default function () {
    let url = window.location.search.slice(1);

    url = url.replace("=%3D", "");
    url = url.replace("e30=", "");
    //url = url.replaceAll("%2520", " ");
    //url = url.replaceAll("%20", " ");

    const boolVal = ['verdtilbod', 'parking', 'notInCountry'];

    if (isBase64(url)) {
        return isBase64(url);
    } else {
        let filter = [];
        url.split("&").map(e => {
            let pa = e.split("=");

            if(boolVal.includes(pa[0])){
                filter[pa[0]] = pa[1];
            }else{
                filter[pa[0]] = pa[1].split(",");
            }
        });
        return filter;
    }
}


function isBase64(url) {
    try {
        let res = window.atob(url)


        return JSON.parse(res);
    } catch (e) {
        return false;
    }
}